import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=9adb9d54&scoped=true&"
import script from "./Detail2.vue?vue&type=script&lang=js&"
export * from "./Detail2.vue?vue&type=script&lang=js&"
import style0 from "./Detail2.vue?vue&type=style&index=0&id=9adb9d54&prod&lang=scss&"
import style1 from "./Detail2.vue?vue&type=style&index=1&id=9adb9d54&prod&lang=scss&scoped=true&"
import style2 from "./Detail2.vue?vue&type=style&index=2&id=9adb9d54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adb9d54",
  null
  
)

export default component.exports